module.exports = __webpack_public_path__ + "media/images/order_arrow-89d6f969.png";